export default __webpack_public_path__ + "static/icon-19-4-83477d1d1c4ccb6a8a45aa32a8a0b765.png";